import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.whiteish,
  tileBgColor: colors.whiteish,
  iconBgColor: colors.azure
};
export default imageGallery;